import { ComandasProvider } from './../../providers/comandas/comandas';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { DomiciliosappProvider } from '../../providers/domiciliosapp/domiciliosapp'
import { SelectSearchable } from 'ionic-select-searchable';
import { Storage } from '@ionic/storage'
import { UUID } from 'angular2-uuid';
import { PushProvider } from '../../providers/push/push'
import { PushPage } from '../../pages/push/push'

@IonicPage()
@Component({
  selector: 'page-grupos-productos-domicilios-descripcion',
  templateUrl: 'grupos-productos-domicilios-descripcion.html',
})
export class GruposProductosDomiciliosDescripcionPage {
  data:any[] = []
  gruposProductosDomiciliosDescripcion:any[] = []
  gruposProductosDomiciliosDescripcionDescuentoInventario :any[] = []
  gruposProductosDomiciliosDescripcionSeleccionMultiple :any[] = []
  gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple :any[] = []
  agrupado:any[] = []
  agrupadoSeleccionMultiple:any[] = []
  agrupadoReal:any[] = []
  contadorReal:any[] = []
  agrupadoRealSecundario:any[] = []
  sumarSeleccion:number = 0;
  pushcantidad:number=0;
  push:boolean = false
  cantidad:number =0;
  constructor(public navCtrl: NavController, public navParams: NavParams,public modalControllers:ModalController,
    public servicioDomicilios:DomiciliosappProvider,
    public storages:Storage,public servicioPush:PushProvider,
    public servicioComandas:ComandasProvider) {
    this.buscarPush()
    if(this.navParams.get('item')){
     this.data = this.navParams.get('item')

     this.buscarDatos(this.data)
    }
  }

  buscarDatos(data:any){
    let cantidad = data.cantidad
    this.cantidad = data.cantidad
    let valorVenta = data.valorVenta

    this.servicioDomicilios.buscargruposProductosDomiciliosDescripcion(data['domiciliosAddgruposUuid'],data['domiciliosAddproductosUuid'])
    .subscribe((data=>{

      this.contadorReal.push({'cantidad':cantidad,'valorVenta':valorVenta,'descripcion':'',sumarSeleccion:0})
      this.gruposProductosDomiciliosDescripcion = data[0]
      this.gruposProductosDomiciliosDescripcionDescuentoInventario = data[1]
      this.gruposProductosDomiciliosDescripcionSeleccionMultiple = data[2]
      this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple = data[3]

      for(var i = 0; i < this.gruposProductosDomiciliosDescripcion.length;i++){
        let valor = this.gruposProductosDomiciliosDescripcion[i]['domiciliosAddDescripcionUuid']
        this.agrupado.push({
          'domiciliosAddDescripcionUuid':this.gruposProductosDomiciliosDescripcion[i]['domiciliosAddDescripcionUuid'],
          'nombre':this.gruposProductosDomiciliosDescripcion[i]['nombre'],'tipo':'PRINCIPAL',
          'cantidad':this.gruposProductosDomiciliosDescripcion[i]['cantidad'],
          'valorVenta':this.gruposProductosDomiciliosDescripcion[i]['valorVenta'] == undefined ? 0 : this.gruposProductosDomiciliosDescripcion[i]['valorVenta'] ,
          'domiciliosAddGruposProductosContenidoUuid':this.gruposProductosDomiciliosDescripcion[i]['domiciliosAddGruposProductosContenidoUuid'],
          'check':false,
          'productosId':this.gruposProductosDomiciliosDescripcion[i].productosId,
          'descripcion':this.gruposProductosDomiciliosDescripcion[i].descripcion
        })

        for(var Z=0;Z < this.gruposProductosDomiciliosDescripcionDescuentoInventario.length;Z++){
          if(this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['domiciliosAddDescripcionUuid'] === valor){
            this.agrupado.push({
              'domiciliosAddDescripcionUuid':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['domiciliosAddDescripcionUuid'],
              'nombre':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['alias'],'tipo':'SECUNDARIO',
              'cantidad':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['cantidad'],
              'valorVenta':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['valorVenta'] == undefined ? 0 : this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['valorVenta'] ,
              'domiciliosAddGruposProductosContenidoUuid':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z]['domiciliosAddGruposProductosContenidoUuid'],
             'check':false,
             'productosId':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z].productosId,
             'descripcion':this.gruposProductosDomiciliosDescripcionDescuentoInventario[Z].descripcion
            })
          }
        }
      }

      for(var ii = 0; ii < this.gruposProductosDomiciliosDescripcionSeleccionMultiple.length;ii++){
        let valorSeleccionMultiple = this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['domiciliosAddDescripcionUuid']

        this.agrupadoSeleccionMultiple.push({
          'domiciliosAddDescripcionUuid':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['domiciliosAddDescripcionUuid'],
          'nombre':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['nombre'],'tipo':'PRINCIPAL',
          'cantidad':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['cantidad'],
          'valorVenta':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['valorVenta'] == undefined ? 0 : this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['valorVenta'] ,
          'domiciliosAddGruposProductosContenidoUuid':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii]['domiciliosAddGruposProductosContenidoUuid'],
          'check':false,
          'productosId':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii].productosId,
          'descripcion':this.gruposProductosDomiciliosDescripcionSeleccionMultiple[ii].descripcion
        })

        for(var ZZ=0;ZZ < this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple.length;ZZ++){
          if(this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['domiciliosAddDescripcionUuid'] === valorSeleccionMultiple){
            this.agrupadoSeleccionMultiple.push({
              'domiciliosAddDescripcionUuid':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['domiciliosAddDescripcionUuid'],
              'nombre':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['alias'],'tipo':'SECUNDARIO',
              'cantidad':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['cantidad'],
              'valorVenta':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['valorVenta'] == undefined ? 0 : this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['valorVenta'] ,
              'domiciliosAddGruposProductosContenidoUuid':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ]['domiciliosAddGruposProductosContenidoUuid'],
             'check':false,
             'productosId':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ].productosId,
             'descripcion':this.gruposProductosDomiciliosDescripcionDescuentoInventarioSeleccionMultiple[ZZ].descripcion
            })
          }
        }
      }

    }))
  }

  disminuirUnProductoAgrupado(item, index) {
    let nuevaCantidad = Number(item['cantidad']) - 1
    if(nuevaCantidad <= 0){

    }else{
        this.agrupado[index]['cantidad'] = nuevaCantidad
    }
    // let nuevaCantidad = 0
    // if(index == 0){
    //   nuevaCantidad = item.cantidad - 1
    //   if(nuevaCantidad<=0){
    //     this.agrupado[index]['cantidad'] = 1
    //     this.contadorReal[0].cantidad = 1

    //   }else{
    //     this.agrupado[index]['cantidad'] = nuevaCantidad
    //     item.cantidad = nuevaCantidad
    //     this.contadorReal[0].cantidad = nuevaCantidad

    //   }

    // }else{
    //   nuevaCantidad = item.cantidad - 1
    //   if(nuevaCantidad<=0){
    //     this.agrupado[index - 1]['cantidad'] = 1
    //     item.cantidad = 1
    //     this.contadorReal[0].cantidad = 1

    //   }else{
    //     this.agrupado[index - 1]['cantidad'] = nuevaCantidad
    //     item.cantidad = nuevaCantidad
    //     this.contadorReal[0].cantidad = nuevaCantidad

    //   }
    // }
    // this.buscarValorVenta('D')

}

disminuirUnProductoAgrupadoSeleccionMultiple(item, index) {
  let nuevaCantidad = Number(item['cantidad']) - 1
  if(nuevaCantidad <= 0){

  }else{
      this.agrupadoSeleccionMultiple[index]['cantidad'] = nuevaCantidad
  }


}

cambiarCheck(item, index){
  item.check = !item.check
  let valorCheck = item.check

  let id = item.domiciliosAddGruposProductosContenidoUuid
  let idgrupo = item.domiciliosAddDescripcionUuid
  let length = this.agrupado.length

  for(let i = 0;i< length;i++){
      if(this.agrupado[i].domiciliosAddDescripcionUuid === idgrupo &&   item.tipo=='SECUNDARIO'){
      {

        let gruposProductosDomicilios = this.agrupado.filter( item => item.domiciliosAddDescripcionUuid === idgrupo && item.tipo === 'SECUNDARIO' )
        let lengthGrupos = gruposProductosDomicilios.length
        if(gruposProductosDomicilios.length > 0){
          for(let k = 0;k<lengthGrupos;k++){
            if(gruposProductosDomicilios[k].domiciliosAddGruposProductosContenidoUuid === id){
              gruposProductosDomicilios[k]['check'] = true

              // cantidad: 1
              // check: false
              // descripcion: null
              // domiciliosAddGruposProductosContenidoUuid: "14"
              // domiciliosAddDescripcionUuid: "8"
              // nombre: "Fresa"
              // productosId: "67"
              // tipo: "SECUNDARIO"
              // valorVenta: 3500
            }else{
              gruposProductosDomicilios[k]['check'] = false
            }
          }
        }

        this.buscarValorVenta()
        this.agrupado[index]['check'] = true
      }

    }

  }

}
cambiarCheckSeleccionMultiple(item, index){

  item.check = !item.check
  let valorCheck = item.check

  let id = item.domiciliosAddGruposProductosContenidoUuid
  let idgrupo = item.domiciliosAddDescripcionUuid
  let length = this.agrupadoSeleccionMultiple.length

  for(let i = 0;i< length;i++){
      if(this.agrupadoSeleccionMultiple[i].domiciliosAddDescripcionUuid === idgrupo &&   item.tipo=='SECUNDARIO'){
      {

        let gruposProductosDomicilios = this.agrupadoSeleccionMultiple.filter( item => item.domiciliosAddDescripcionUuid === idgrupo && item.tipo === 'SECUNDARIO' )
        let lengthGrupos = gruposProductosDomicilios.length
        if(gruposProductosDomicilios.length > 0){
          for(let k = 0;k<lengthGrupos;k++){
            if(gruposProductosDomicilios[k].domiciliosAddGruposProductosContenidoUuid === id){
              // gruposProductosDomicilios[k]['check'] = true
            }else{
              // gruposProductosDomicilios[k]['check'] = false
            }
          }
        }

        this.buscarValorVentaSeleccionMultiple()
        this.agrupadoSeleccionMultiple[index]['check'] = true
      }

    }

  }

}

buscarValorVentaSeleccionMultiple(disminuir?:any){
  let length = this.agrupadoSeleccionMultiple.length
  let valorVenta = 0
  let nuevaCantidad = 0
    for(let i = 0;i< length;i++){
    if(this.agrupadoSeleccionMultiple[i].check === true){

      //////afn nuevaCantidad = this.agrupadoSeleccionMultiple[i]['cantidad']
      if(this.agrupadoSeleccionMultiple[i].productosId != '0'){
        valorVenta = this.agrupadoSeleccionMultiple[i].valorVenta
        i = i + length
      }
     }
    }
    this.contadorReal[0].sumarSeleccion= valorVenta
    if(disminuir !=='D'){
      ////// afn this.contadorReal[0].cantidad = nuevaCantidad
    }

  }


buscarValorVenta(disminuir?:any){
  let length = this.agrupado.length
  let valorVenta = 0
  let nuevaCantidad = 0
    for(let i = 0;i< length;i++){
    if(this.agrupado[i].check === true){

      //////afn nuevaCantidad = this.agrupado[i]['cantidad']
      if(this.agrupado[i].productosId != '0'){
        valorVenta = this.agrupado[i].valorVenta
        i = i + length
      }
     }
    }
    this.contadorReal[0].sumarSeleccion= valorVenta
    if(disminuir !=='D'){
      ////// afn this.contadorReal[0].cantidad = nuevaCantidad
    }

  }

  aumentarUnProductoAgrupado(item,index) {

    let nuevaCantidad = Number(item['cantidad']) + 1

    // index = this.buscarIndex(item,index)
    this.agrupado[index]['cantidad'] = nuevaCantidad

    // let nuevaCantidad = 0
    // let valorVenta = 0
    // let length = this.agrupado.length
    // for(let i = 0;i< length;i++){
    // if(this.agrupado[i].check === true){
    //   nuevaCantidad = this.agrupado[i]['cantidad']

    //   if(this.agrupado[i].productosId != '0'){
    //     valorVenta =this.agrupado[i].valorVenta
    //     this.agrupado[i]['cantidad']  = nuevaCantidad + 1
    //     i = i + length
    //   }else{
    //     this.contadorReal[0].descripcion = this.agrupado[i]['nombre']
    //   }
    //  }
    // }


    //   this.contadorReal[0].cantidad = nuevaCantidad + 1
    //   this.contadorReal[0].valorVenta = valorVenta

  }

  aumentarUnProductoAgrupadoSeleccionMultiple(item,index) {

    let nuevaCantidad = Number(item['cantidad']) + 1

    this.agrupadoSeleccionMultiple[index]['cantidad'] = nuevaCantidad



  }

  ionViewDidLoad() {
    this.buscarPush()
  }

  agregarAlCarrito(item) {

    // this.realizandoUnaVenta = true
    // verificar si el producto ya no esta agregado
    let productosId = item['productosId']
    // let contarProductosConElMismoId = this.listaProductosSeleccionados.filter( item => item.productosId === productosId )
    let tipoProducto = item['tipoProducto']
    // let contarProductosConElMismoId = this.listaProductosSeleccionados.filter( item => item.productosId === productosId && item.tipoProducto === tipoProducto )
    // if(contarProductosConElMismoId.length > 0){
    //     // el producto ya existe en el carrito
    //     return
    // }
    // el producto aun no ha sido agregado
    // item['cantidad'] = 1
    // this.listaProductosSeleccionados.push(item)
    // let valorTotalVentaNum =  0
    // let valorTotalProductosNum =  0
    // let valorTotalImpuestosNum =  0
    // valorTotalVentaNum =  Number(this.valorTotalVenta) +  Number(item['valorVenta'])
    // valorTotalProductosNum =  Number(this.valorTotalProductos) +  Number(item['valorProducto'])
    // valorTotalImpuestosNum =  Number(this.valorTotalImpuestos) +  Number(item['valorImpuesto'])
    // this.valorTotalVenta = valorTotalVentaNum
    // this.valorTotalProductos = valorTotalProductosNum
    // this.valorTotalImpuestos = valorTotalImpuestosNum

    // var container = document.getElementById('mita44');
    // var rowToScrollTo = document.getElementById('prueba44');

    // // container.scrollTop = rowToScrollTo.offsetTop;
    // container.scrollTop = rowToScrollTo.offsetTop;

}

  agregarPedido(){
    this.agrupadoRealSecundario = []
    this.storages.set('agrupadoRealSecundario',[])
    for(let i = 0;i< this.agrupado.length;i++){
       if(this.agrupado[i]['check']){
         this.agrupadoRealSecundario.push({
           'domiciliosAddDescripcionUuid':this.agrupado[i].domiciliosAddDescripcionUuid,
           'nombre':this.agrupado[i].nombre,
           'tipo':this.agrupado[i].tipo,
           'cantidad':this.contadorReal[0].cantidad,
           'valorVenta':this.agrupado[i].valorVenta ,
           'domiciliosAddGruposProductosContenidoUuid':this.agrupado[i].domiciliosAddGruposProductosContenidoUuid,
           'check':this.agrupado[i].check,
           'productosId':this.agrupado[i].productosId,
           'descripcion':this.agrupado[i].descripcion

         })
          this.agrupado[i].check = false

       }
       }

    this.storages.get('agrupadoRealSecundario').then((val)=>{
      let lengthRealInicial = this.agrupadoRealSecundario.length
      let idInicial = 0
      let idInicialOriginal = 0
      let datosGuardarInicial = []
      let valoresDescripcion = "-"

      if(val &&  lengthRealInicial == 2){
        for(let z = 0;z < lengthRealInicial;z++){
          if(this.agrupadoRealSecundario[z]['productosId'] !=='0'){
            idInicial = z
            datosGuardarInicial.push(this.agrupadoRealSecundario[z])
          }else{
            let desc = this.agrupadoRealSecundario[z].descripcion === undefined ? '-' : this.agrupadoRealSecundario[z].descripcion;
            let nomb = this.agrupadoRealSecundario[z].nombre === undefined ? '-' : this.agrupadoRealSecundario[z].nombre;
            valoresDescripcion += ` ${desc} ${nomb} `
            idInicialOriginal = this.agrupadoRealSecundario[z].domiciliosAddGruposProductosContenidoUuid
          }
        }
       datosGuardarInicial[0].id = idInicialOriginal
        for(let i =0;i<lengthRealInicial;i++){
           let idgrupo = this.agrupadoRealSecundario[i].domiciliosAddDescripcionUuid
           let domiciliosAddGruposProductosContenidoUuid = this.agrupadoRealSecundario[i].domiciliosAddGruposProductosContenidoUuid

           let existeValorInicial = val.filter( item => item.domiciliosAddDescripcionUuid == idgrupo && item.domiciliosAddGruposProductosContenidoUuid == domiciliosAddGruposProductosContenidoUuid)
          if(existeValorInicial.length > 0){
          }else{
            let uuid = UUID.UUID();
            let uuidUlt = UUID.UUID()
            let Uuid = `${uuid.substr(0,6)}-${uuidUlt.substr(0,6)}`
            datosGuardarInicial[0].codigo = Uuid
            val.push(datosGuardarInicial[0])
          }
        }

        this.getMultipleStorage(val)

      }else{
        let lengthSecundario = this.agrupadoRealSecundario.length
        let datosGuardar = []
        let valoresDescripcion = ''
        if(lengthSecundario>0){
          let uuid = UUID.UUID();
          let uuidUlt = UUID.UUID()
          let Uuid = `${uuid.substr(0,6)}-${uuidUlt.substr(0,6)}`
          let id = 0
          let idOriginal = 0
          for(let z = 0;z < lengthSecundario;z++){
            this.agrupadoRealSecundario[z]['codigo'] = Uuid
            if(this.agrupadoRealSecundario[z]['productosId'] !=='0'){
              id = z
              datosGuardar.push(this.agrupadoRealSecundario[z])
            }else{
              valoresDescripcion += ` ${this.agrupadoRealSecundario[z].descripcion} ${this.agrupadoRealSecundario[z].nombre} `
              idOriginal = this.agrupadoRealSecundario[z].domiciliosAddGruposProductosContenidoUuid
            }
          }
          if(datosGuardar.length === 0 && this.agrupadoRealSecundario.length>0){
            datosGuardar.push(this.agrupadoRealSecundario[0])
            datosGuardar[0].descripcion += ` ${this.agrupadoRealSecundario[id].nombre} : ${valoresDescripcion} `
            datosGuardar[0].id = idOriginal
          }else{
            datosGuardar[0].descripcion = ` ${this.agrupadoRealSecundario[id].nombre} : ${valoresDescripcion} `
            datosGuardar[0].id = idOriginal
          }

          // this.storages.set('agrupadoRealSecundario',datosGuardar)

          this.getMultipleStorage(datosGuardar)
        }
      }
      this.limpiar()
    })
 }

  limpiar(){
    this.gruposProductosDomiciliosDescripcion = []
    this.gruposProductosDomiciliosDescripcionDescuentoInventario  = []
    this.agrupado = []
    this.agrupadoReal = []
    this.contadorReal = []
    this.agrupadoRealSecundario = []
    this.buscarDatos(this.data)
  }

  buscarPush(){

    this.storages.get('companiasId').then((val)=>{
      if(val){
        this.servicioPush.buscar(val).subscribe((data)=>{

          if(data[1][0].pushcantidad>0){

            this.pushcantidad = data[1][0].pushcantidad
          }else{
            this.pushcantidad = 0
          }
        },(error)=>{

          console.log(error)
        })
      }

    })
  }

  ionViewWillLoad(){
   this.buscarPush()
  }

  pushMensaje(){
    this.push = !this.push
    let datos = []
    let modal = this.modalControllers.create(PushPage, { datos })
    modal.present();

    modal.onDidDismiss(data => {
     this.buscarPush()
    })
  }
  getMultiple(keys: string[]) {
    const promises = [];

    keys.forEach( key => promises.push(this.storages.get(key)) );

    return Promise.all(promises).then( values => {
      const result = {};

      values.map( (value, index) => {
        result[keys[index]] = value;
      });

      return result;
    });
}
getMultipleStorage(val:any) {
  this.getMultiple(['usuariosId','companiasId','clientesId','cantidad'])
  .then( res => {

      let usuariosId = res['usuariosId']
      let companiasId = res['companiasId']
      let clientesId = res['clientesId']
      let cantidad = res['cantidad']
      val['usuariosId'] = usuariosId
      val['companiasId'] = companiasId
      val['clientesId'] = clientesId
      val['cantidad'] = cantidad
      val['cantidad'] = cantidad
      // descripcion

      for(let i=0;i<val.length;i++){
        if(i + 1 == val.length){
          val[i]['usuariosId'] = usuariosId
          val[i]['companiasId'] = companiasId
          val[i]['clientesId'] = clientesId
          val[i]['cantidad'] = cantidad
          // val[i]['descripcion'] = cantidad
          val[i]['domicilio'] = "N"
          val[i]['estado'] = "G"
          let codigo = val[i]['codigo']
          this.servicioComandas.guardarComandasGrupos(val,codigo)
          .subscribe((data)=>{
            console.log(data)
            this.storages.set('agrupadoRealSecundario',[])
          },(error)=>{
            this.storages.set('agrupadoRealSecundario',[])
            console.log(error)
          })
        }

      }

      // this.storages.set('agrupadoRealSecundario',val)
  })
}
}



// WEBPACK FOOTER //
// ./src/pages/grupos-productos-domicilios-descripcion/grupos-productos-domicilios-descripcion.ts